import { useEffect, useRef } from 'react';
import { useConfig } from './useConfig';

declare global {
  var NREUM: any;
}

export const useNewRelic = () => {
  const { config, loading } = useConfig();
  const initializingRef = useRef(false);
  const initializedRef = useRef(false);

  useEffect(() => {
    if (loading || !config.FE_NEW_RELIC_BROWSER_LICENSE_KEY || !config.FE_NEW_RELIC_APPLICATION_ID) {
      return;
    }

    // Prevent multiple initializations
    if (initializedRef.current || initializingRef.current) {
      return;
    }

    // Only initialize if not already loaded
    if (globalThis.NREUM || document.getElementById('newrelic-js-agent')) {
      initializedRef.current = true;
      return;
    }

    initializingRef.current = true;

    // Initialize NREUM object first
    globalThis.NREUM = globalThis.NREUM || {};
    
    // Set up New Relic configuration
    globalThis.NREUM.loader_config = {
      accountID: config.FE_NEW_RELIC_APPLICATION_ID,
      trustKey: config.FE_NEW_RELIC_APPLICATION_ID,
      agentID: config.FE_NEW_RELIC_APPLICATION_ID,
      licenseKey: config.FE_NEW_RELIC_BROWSER_LICENSE_KEY,
      applicationID: config.FE_NEW_RELIC_APPLICATION_ID
    };
    
    globalThis.NREUM.info = {
      beacon: "bam.nr-data.net",
      errorBeacon: "bam.nr-data.net",
      licenseKey: config.FE_NEW_RELIC_BROWSER_LICENSE_KEY,
      applicationID: config.FE_NEW_RELIC_APPLICATION_ID,
      sa: 1
    };

    // Load the New Relic script
    const script = document.createElement('script');
    script.src = 'https://js-agent.newrelic.com/nr-loader-spa-current.min.js';
    script.id = 'newrelic-js-agent';
    script.async = true;
    
    script.onload = () => {
      // console.log('New Relic Browser Agent loaded successfully');
      initializedRef.current = true;
      initializingRef.current = false;
    };
    
    script.onerror = () => {
      console.error('Failed to load New Relic Browser Agent');
      initializingRef.current = false;
    };
    
    document.head.appendChild(script);

  }, [config, loading]);
};